import useFrontendBoot from "@/Hooks/useFrontendBoot";
import useToggleHandler from "@/Hooks/useToggleHandler";
import QuickProductCreationModal from "@/Pages/Home/components/QuickProductCreationModal";
import { sideTabSchema } from "@/Routes/sidebar.utility";
import { Image, MenuSelect } from "@repo/ui/index.tsx";
import TraceIdComp from "customer/TraceIdComp";
import QuickSearch from "./components/QuickSearch";

import useRoutesHandler from "@/Hooks/useRouteHandler";
import {
  CubeIcon,
  DocumentTextIcon,
  LinkIcon,
  PlusCircleIcon,
  RectangleStackIcon,
} from "@heroicons/react/24/outline";

interface INavbar {
  TABS: sideTabSchema[];
}
function Navbar({ TABS }: INavbar) {
  const { logo } = useFrontendBoot();
  const { navigate } = useRoutesHandler();

  const {
    isOpen: isQuickProductCreationModal,
    toggler: quickProductCreationModalToggler,
  } = useToggleHandler();
  return (
    <nav className="flex max-h-18 items-center pt-4 px-2 md:px-6 pb-4 z-30 justify-between sticky top-0 bg-white border-b border-extraLightGray/50  rounded-t-3xl max-[450px]:hidden">
      <div className="flex items-center gap-4 w-fit">
        {logo ? (
          <Image
            src={logo}
            alt="company logo"
            containerClass="h-14 w-28 ring-1 ring-offWhite rounded-md "
            className="h-full object-contain"
          />
        ) : (
          <div className="h-[3.5rem] rounded-lg w-[10rem] bg-extraLightGray animate-pulse" />
        )}
      </div>
      <div className="flex flex-1 gap-4 justify-end items-center">
        <TraceIdComp />
        <QuickSearch TABS={TABS} />

        {import.meta.env.VITE_USER === "broker" && (
          <MenuSelect
            icon={<PlusCircleIcon className="size-7" />}
            className="text-primary/80 w-10 h-10 border border-primary/30 bg-primary/5 "
            containerClass="text-body/90 [&>*]:h-10 [&>*]:border-b [&>*]:border-extraLightGray"
            label="Quick Action"
            options={[
              {
                name: "Add Product",
                icon: <CubeIcon />,
                onClick: () => {
                  quickProductCreationModalToggler();
                },
              },
              {
                name: "Add Policy",
                icon: <DocumentTextIcon />,
                onClick: () => {
                  navigate("/plan-config/policies/add");
                },
              },
              {
                name: "Add Plan",
                icon: <RectangleStackIcon />,
                onClick: () => {
                  navigate("/plan-config/plans/add");
                },
              },
              {
                name: "Add Journey Link",
                icon: <LinkIcon />,
                onClick: () => {
                  navigate("/journey-config/journey-links/add");
                },
              },
            ]}
          />
        )}
      </div>

      {isQuickProductCreationModal && (
        <QuickProductCreationModal
          isOpen={isQuickProductCreationModal}
          toggler={quickProductCreationModalToggler}
        />
      )}
    </nav>
  );
}

export default Navbar;
